module.exports = __webpack_public_path__ + "img/ufton_b1.3ee5eb24.jpg";